<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

import {computed, onMounted, ref} from "vue";
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import CompetitorRow from "@/components/competition/partials/CompetitorRow.vue";
import {useStore} from "vuex";
import useWebsite from "@/composables/useWebsite";

const newCompetitor = ref('');

const activeTab = ref('competitors')

const loadingNewCompetitor = ref(false);

const store = useStore();

onMounted(() => {
  store.dispatch('competitionV2/fetchCompetitors');
  store.dispatch('competitionV2/fetchSuggestedCompetitors');

  // prefilling the competitor url if website is passed in query params
  const queryParams = new URLSearchParams(window.location.search);
  const websiteParam = queryParams.get('website');
  if (websiteParam) {
    newCompetitor.value = decodeURIComponent(websiteParam);
  }
})

const competitors = computed(() => store.getters['competitionV2/competitors'].filter((competitor) => !competitor.isWebsiteAsCompetitor));
const recommended = computed(() => store.getters['competitionV2/suggestedCompetitors']);
const { website } = useWebsite();

const addNewCompetitor = () => {
  loadingNewCompetitor.value = true;
  store.dispatch('competitionV2/addCompetitor', newCompetitor.value).then(() => {
    newCompetitor.value = '';
    loadingNewCompetitor.value = false;
  }).catch(() => {
    loadingNewCompetitor.value = false;
  })
}

</script>

<template>
  <div>
    <form
      class="tw-mb-8"
      @submit.prevent="addNewCompetitor"
    >
      <label class="tw-border-2 tw-border-grey-mid tw-rounded-md tw-flex tw-text-black tw-col-span-12 mb-4">
        <svg-vue
          icon="icons/text-input"
          class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
        />
        <input
          v-model="newCompetitor"
          placeholder="Enter Competitor URL"
          class="tw-border-0 tw-w-full tw-pl-3 tw-text-lg tw-pr-2"
          type="search"
        >
      </label>

      <div
        v-if="website"
        class="tw-flex"
      >
        <DefaultButton
          type="submit"
          class="tw-w-full"
          :disabled="loadingNewCompetitor"
        >
          <svg-vue
            v-if="loadingNewCompetitor"
            icon="icons/loading"
            class="tw-h-6 tw-w-6 tw-mr-3"
          />
          <svg-vue
            v-else
            icon="icons/add-competitor"
            class="tw-h-6 tw-w-6 tw-mr-3"
          />
          <span class="tw-font-normal">Add Competitor</span>
        </DefaultButton>
      </div>
    </form>

    <div class="tw-overflow-y-auto tw-max-h-[95vh] tw-pr-2 tw--mr-4">
      <div class="mb-4 tw-sticky tw-top-0 tw-bg-white tw-drop-shadow-[0_20px_10px_rgb(255,255,255)]">
        <TabContainer>
          <TabItem
            :active="activeTab === 'competitors'"
            class="tw-gap-2"
            @click="activeTab = 'competitors'"
          >
            <svg-vue
              icon="icons/search-competitors"
              class="tw-w-6 tw-h-6"
            />
            <span>Competitors</span>
          </TabItem>
          <TabItem
            :active="activeTab === 'recommended'"
            class="tw-gap-2"
            @click="activeTab = 'recommended'"
          >
            <svg-vue
              icon="icons/recommended"
              class="tw-w-6 tw-h-6"
            />
            <span>Recommended</span>
          </TabItem>
        </TabContainer>
      </div>
      <div
        class="tw-gap-4 tw-flex tw-flex-col tw-pb-4"
      >
        <CompetitorRow
          v-for="competitor in (activeTab === 'competitors' ? competitors : recommended)"
          :key="competitor.simpleUrl"
          :competitor="competitor"
        />
      </div>
    </div>
    <div class="tw-bg-white tw-h-4 tw--mr-4 tw-relative tw-top--4 tw-drop-shadow-[0_-10px_5px_rgb(255,255,255)]" />
  </div>
</template>
